module.exports = __webpack_public_path__ + "img/joomla.d8aa2e45.svg";